import React, { useContext, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { AppContext } from "../App";
import { documentCategories } from "../data/documentCategories";
import { motion } from "framer-motion";
import GlassCard from "../components/GlassCard";
import { ExternalLink } from "lucide-react";

/* ✅ ΠΡΟΣΘΗΚΗ */
import SubcategoryInlineAd from "../components/ads/SubcategoryInlineAd";

const SubcategoryPage = () => {
  const { id } = useParams();
  const { language } = useContext(AppContext);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  let foundSub = null;
  let parentCategory = null;

  for (const cat of documentCategories) {
    const sub = cat.subcategories?.find((s) => s.id === id);
    if (sub) {
      foundSub = sub;
      parentCategory = cat;
      break;
    }
  }

  if (!foundSub) return null;

  const bgImage = foundSub.backgroundImage || parentCategory.backgroundImage;

  return (
    <motion.div
      className="relative min-h-screen flex flex-col items-center text-center px-6 pt-5"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
      }}
    >
      <div className="absolute inset-0 bg-black/40 z-0"></div>

      {/* GRID */}
      <div
        className="
          grid gap-6
          grid-cols-1 sm:grid-cols-2 lg:grid-cols-3
          justify-items-center
          mt-10 max-w-6xl w-full px-4 sm:px-6 relative z-10
        "
      >
        {foundSub.links.map((link, i) => (
          <GlassCard
            key={i}
            icon={ExternalLink}
            title={language === "el" ? link.name : link.nameEn}
            desc={language === "el" ? link.description : link.descriptionEn}
            onClick={() => window.open(link.url, "_blank")}
          />
        ))}
      </div>

      {/* ✅ ΔΙΑΦΗΜΙΣΗ */}
      <SubcategoryInlineAd />

      <div className="flex gap-4 mt-10 mb-20 relative z-10">
        <button
          onClick={() => navigate(`/category/${parentCategory.id}`)}
          className="glass-btn"
        >
          {language === "el" ? "Πίσω στην Κατηγορία" : "Back to Category"}
        </button>
        <button onClick={() => navigate("/")} className="glass-btn">
          {language === "el" ? "Πίσω στην Αρχική" : "Back to Home"}
        </button>
      </div>
    </motion.div>
  );
};

export default SubcategoryPage;
